import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Alert, AlertTitle, Stack, Typography, styled } from '@mui/material';
import React from 'react';
import { VersionMetadata } from '../types';

const StyledErrorContainer = styled('div')(({ theme }) => ({
  minHeight: 500,
  border: '2px solid',
  borderColor: theme.palette.error.main,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(3),
  backgroundColor: theme.palette.error.light,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledErrorIcon = styled(ErrorOutlineIcon)(({ theme }) => ({
  fontSize: 64,
  color: theme.palette.error.main,
}));

interface IncompatibilityErrorProps {
  metadata: VersionMetadata;
}

export function IncompatibilityError({
  metadata,
}: IncompatibilityErrorProps): React.JSX.Element {
  return (
    <StyledErrorContainer>
      <Stack spacing={3} alignItems='center' maxWidth={600}>
        <StyledErrorIcon />

        <Alert severity='error' sx={{ width: '100%' }}>
          <AlertTitle sx={{ fontWeight: 'bold' }}>
            Version
            {` ${metadata.version} `}
            is Not Compatible
          </AlertTitle>
          <Typography variant='body2' paragraph>
            {metadata.incompatibilityReason}
          </Typography>
        </Alert>
      </Stack>
    </StyledErrorContainer>
  );
}
